import { Component, inject, Input, Output, EventEmitter } from '@angular/core';

import { ColumnOptionsService } from '@services/column-options.service';
import { StationColumnOptionsService } from '@services/station-column-options.service';
import { CheckboxComponent } from '@shared/checkbox/checkbox.component';
import { ColumnOption } from '@models/shared.model';

@Component({
    selector: 'app-discrepancy-view-column-options',
    imports: [CheckboxComponent],
    template: ` <p class="mb-3">Column Options</p>
        <div class="column-options">
            @for (item of docColumnOptions; track $index) {
                <app-checkbox
                    size="small"
                    [disabled]="item.disabled"
                    [checked]="item.checked"
                    [label]="item.label"
                    (checkedChange)="updateColumnDisplay($event, item.id)" />
            }
        </div>
        <div class="column-options nested ml-n3 mr-n3 mt-1 p-3">
            @for (item of discColumnOptions; track $index) {
                <app-checkbox
                    size="small"
                    [disabled]="item.disabled"
                    [checked]="item.checked"
                    [label]="item.label"
                    (checkedChange)="updateColumnDisplay($event, item.id)" />
            }
        </div>`,
    styles: `
        :host {
            width: 100%;

            .column-options {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;

                &.nested {
                    background-color: #f5f6f7;
                }
            }
        }
    `,
})
export class DiscrepancyViewColumnOptionsComponent {
    @Input({ required: true }) options: ColumnOption[] = [];
    @Output() disccOptionsChanged = new EventEmitter<{
        checked: boolean;
        id: string;
    }>();

    private readonly columnOptionsService = inject(ColumnOptionsService);
    private readonly stationColumnOptionsService = inject(
        StationColumnOptionsService,
    );

    get docColumnOptions() {
        return this.options.filter((item) => item.group === 'doc');
    }

    get discColumnOptions() {
        return this.options.filter((item) => item.group === 'disc');
    }

    updateColumnDisplay(checked: boolean, id: any) {
        this.disccOptionsChanged.emit({ checked, id });
    }
}
